export const RECEIVE_WEBHOOK_NOTIFICATIONS = 'RECEIVE_WEBHOOK_NOTIFICATIONS';
export const RECEIVE_WEBHOOK_NOTIFICATION = 'RECEIVE_WEBHOOK_NOTIFICATION';
export const ERROR = 'ERROR';
export const ALERT = 'ALERT';
